module.exports = __webpack_public_path__ + "img/Bean - Mockup - 2.2af32674.png";